import { Component, OnInit, OnDestroy, Output, EventEmitter } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subscription as RxjsSubscription } from 'rxjs';
import { Client, Subscription } from 'core/models';
import { ActivatedRoute, Router } from '@angular/router';
import { SubscriptionsService } from 'core/services/subscriptions.service';
import { StoreService } from 'core/services/store.service';
import { ProfileService } from 'core/services';
@Component({
  selector: 'lms-client-subscriptions',
  templateUrl: './client-subscriptions.component.html',
  styleUrls: ['./client-subscriptions.component.scss']
})
export class ClientSubscriptionsComponent implements OnInit, OnDestroy {
  @Output() public formErrorEmit: EventEmitter<object> = new EventEmitter<object>();
  public client: Client;
  public tableDataSource;
  public subscription: Subscription;
  public subscriptionRenewal: Subscription;
  public listSubscription: RxjsSubscription;
  public showAdminCard: boolean;
  public expiredSubscription: boolean;
  public clientSubscriptionsListId = 'CLIENT_SUBSCRIPTIONS_LIST';

  constructor(
    public subscriptionsService: SubscriptionsService,
    public translate: TranslateService,
    public router: Router,
    public route: ActivatedRoute,
    public profileService: ProfileService
  ) {}

  public ngOnInit(): void {
    this.route.data.subscribe((data) => {
      this.client = data['client'];
      if (this.tableDataSource) {
        this.refreshTable();
      }
    });
    this.listSubscription = StoreService.get(this.clientSubscriptionsListId).subscribe((tableDataSource) => {
      this.tableDataSource = tableDataSource;
      if (tableDataSource) {
        this.showAdminCard =
          this.client && this.client.subscriptions.users && this.profileService.canExecute('subscriptions.adminCard');
        this.setCurrentSubscription(tableDataSource.docs);
      }
    });
  }

  public ngOnDestroy(): void {
    this.listSubscription.unsubscribe();
  }

  public onSubscriptionUpdated(): void {
    this.refreshTable();
  }

  public refreshTable(): void {
    this.tableDataSource.refreshData();
    StoreService.update(this.clientSubscriptionsListId, this.tableDataSource);
  }

  public setSubscription(subscription) {
    this.subscription = subscription;
    this.expiredSubscription = subscription ? new Date() > new Date(subscription.endDate) : false;
  }

  public onPlanChanged(plan: any): void {
    this.client.plan = plan;
  }

  /**
   * Emit the error message of the form
   * @param errorEvent
   */
  public setErrorMessage(errorEvent: object): void {
    this.formErrorEmit.emit(errorEvent);
  }

  private setCurrentSubscription(clientSubscriptions): void {
    let currentSubscription = null;
    this.subscriptionRenewal = null;
    if (clientSubscriptions && clientSubscriptions.length) {
      const now = Date.now();
      currentSubscription = clientSubscriptions.find(
        (subscription) => new Date(subscription.startDate).getTime() < now
      );
      if (!currentSubscription) {
        currentSubscription = clientSubscriptions[clientSubscriptions.length - 1];
      }
      if (currentSubscription && currentSubscription.renewal) {
        this.subscriptionRenewal = clientSubscriptions.find(
          (subscription) => subscription.id === currentSubscription.renewal.newSubscription
        );
      }
    }
    this.setSubscription(currentSubscription);
  }
}
